<div class="app-dropdown-wrapper">
  <label *ngIf="label" class="app-dropdown-label">{{ label | translate }}</label>
  <p-select
    [(ngModel)]="value"
    [placeholder]="$any(placeholder) | translate"
    [options]="tree ? processedOptions : options"
    [disabled]="disabled"
    [filter]="filter"
    [filterBy]="filterBy"
    [filterPlaceholder]="filterPlaceholder | translate"
    [showClear]="showClear"
    [loading]="loading"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [optionDisabled]="optionDisabled"
    [group]="group"
    [optionGroupLabel]="groupLabel"
    [optionGroupChildren]="groupChildren"
    [appendTo]="appendTo"
    [autofocus]="autofocus"
    [editable]="editable"
    [attr.maxlength]="maxlength"
    (ngModelChange)="handleChange($event)"
    (onFocus)="handleFocus($event)"
    (onBlur)="handleBlur($event)"
    (onFilter)="handleFilter($event)"
    (onShow)="handleShow()"
    (onHide)="handleHide()"
    (onClear)="handleClear()"
    [overlayOptions]="{ autoZIndex: true }"
    styleClass="app-dropdown"
    [virtualScroll]="true"
    [virtualScrollItemSize]="40"
    [emptyFilterMessage]="'No data' | translate"
  >
    <ng-template let-option pTemplate="selectedItem">
      <span *ngIf="!tree">{{ (option?.label || option) | translate }}</span>
      <span *ngIf="tree">{{ getSelectedLabel() | translate }}</span>
    </ng-template>
    <ng-template let-option pTemplate="item">
      <ng-container *ngIf="!tree">
        <div class="dropdown-item text-wrap">
          <span>{{ (option?.label || option) | translate }}</span>
        </div>
      </ng-container>
    </ng-template>
    <ng-template *ngIf="tree" pTemplate="content">
      <div class="p-select-list">
        <div *ngFor="let parentOption of options" class="dropdown-parent-item">
          <div class="parent-header" (click)="toggleExpand($event, parentOption)">
            <span>{{ parentOption.label }}</span>
            <i class="pi" [ngClass]="parentOption.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div class="children-list" *ngIf="parentOption.expanded">
            <div *ngFor="let child of parentOption.children"
                 class="child-item"
                 [class.selected]="isChildSelected(child)"
                 (click)="selectChild($event, child, parentOption)">
              {{ child.label }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-select>
</div>
